<template>
    <div class="textarea-box">
        <div class="textarea-wrapper">
            <textarea rows="3" placeholder="请输入您要发言的内容" v-model="customText" id="textarea"></textarea>
        </div>
        <div class="submit-wrapper" @click="submitCustom">
            <button>发送</button>
        </div>
    </div>
</template>

<script>
    import { postSay } from "@/api/post";
    import { getSayHTML, dialog } from "@/common/fns";

    export default {
        name: "textarea-box",
        emits: ['closePanel'],
        props: {
            selectCurrent: {
                type: Number,
                default() {
                    return 0;
                }
            }
        },
        data() {
            return {
                customText: ''
            }
        },
        methods: {
            async submitCustom() {
                const myname = window.setting.userInfo.username;
                const text = getSayHTML.normal(this.customText);
                if (!text) {
                    dialog.msg('要发布的内容不能为空', 'top');
                    return;
                }
                const result = await postSay(myname, text);
                if (result.content) {
                    dialog.msg('提交成功', 'top');
                    this.customText = '';

                    document.getElementById('textarea').blur();
                    this.$emit('closePanel');
                }
            }
        },
        watch: {
            selectCurrent(newval) {
                if (newval == 3) {
                    this.$nextTick(() => {
                        document.getElementById('textarea').focus();
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .textarea-box{
        display: flex;
        justify-content: space-between;
        padding-bottom: 15px;
    }
    .textarea-wrapper{
        display: inline-block;
        flex: 1;
        border-radius: 10px 0 0 10px;
        overflow: hidden;
    }
    textarea{
        display: block;
        width: 100%;
        padding: 10px;
    }
    .submit-wrapper{
        flex: 0 0 70px;
        border-radius: 0px 10px 10px 0px;
        overflow: hidden;
    }
    .submit-wrapper button{
        width: 100%;
        height: 100%;
        background-color: #C4473D;
        color: #fff;
    }
    .submit-wrapper button:active{
        background-color: #A2372F;
    }
</style>
